import React, { FC } from 'react';
import styles from './WhiteboxBanner.module.scss';

export interface WhiteboxBannerProps {
  h1: string;
  imageSrc: string;
  referenceUrl: string;
  height: number;
  buttonLabel: string;
}

const WhiteboxBanner: FC<WhiteboxBannerProps> = ({ h1, imageSrc, referenceUrl, height: bannerHeight, buttonLabel }) => {
  const height = bannerHeight ? `${bannerHeight}px` : 'auto';

  return (
    <div className={styles.whitebox}>
      <div className={styles.container}>
        <div className={styles.banner}>
          <img className={styles.image} src={imageSrc} alt="Banner" style={{ height }} />
        </div>
        <div className={styles.textContainer}>
          <div className={styles.textBox}>
            <div className={styles.header}>{h1}</div>
            <a href={referenceUrl} className={styles.button}>
              {buttonLabel}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhiteboxBanner;
